import APIClient from '@/shared/http/clients/api'

const resourceName = 'RECredenciadaCorretor'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAllBrokerAccredited = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllAccreditedBroker/${id}`, data, config)
const GetAllPaging = (id, limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllAccreditedBroker/${id}?limit=${limit}&index=${index}`, data, config)
const PutInativeBrokerAccredited = (id, ativar, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/${id}/${ativar}`, data, ativar, config)
const DeleteBrokerAccredited = (id, data, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, data, config)
const Add = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const GetUnboundBrokers = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetUnboundBrokers/${id}`, data, config)
const PostCredenciadaCorretorWeb = (CorretorId, CredenciadaId, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/PostCredenciadaCorretorWeb/${CorretorId}/${CredenciadaId}`, data, config)

const AccreditedbrokerRepository = {

  GetAllBrokerAccredited,
  GetAllPaging,
  PutInativeBrokerAccredited,
  DeleteBrokerAccredited,
  Add,
  GetUnboundBrokers,
  PostCredenciadaCorretorWeb

}

export default AccreditedbrokerRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/accreditedbroker.js